[
  {
    "minLevel": 1,
    "maxLevel": 19,
    "requirement": 20,
    "rewardGems": 200
  },
  {
    "minLevel": 20,
    "maxLevel": 49,
    "requirement": 30,
    "rewardGems": 200
  },
  {
    "minLevel": 50,
    "maxLevel": 99,
    "requirement": 30,
    "rewardGems": 200
  },
  {
    "minLevel": 100,
    "requirement": 30,
    "rewardGems": 200
  }
]
